import { CornerStyle, Layout } from '../shared-components/styleTypes';
import { ITEM_FIELDS as FRAME_FIELDS } from '../shared-components/ConfigPanel/configPanelTypes';

export type CarouselParameters = {
	cards: Frame[];
	cornerStyle?: CornerStyle;
	extensionTitle: string;
	isAutoplayEnabled?: boolean;
	navigationStyle?: NavigationStyle;
	version: string;
};

export type Frame = {
	[FRAME_FIELDS.CARD_ID]: string;
	[FRAME_FIELDS.LINK]: string;
	[FRAME_FIELDS.IS_LINK_USER_EDITED]?: boolean;
	[FRAME_FIELDS.TITLE]?: string;
	[FRAME_FIELDS.IS_TITLE_USER_EDITED]?: boolean;
	[FRAME_FIELDS.DESCRIPTION]?: string;
	[FRAME_FIELDS.IS_DESCRIPTION_USER_EDITED]?: boolean;
	[FRAME_FIELDS.IMAGE_SRC]?: string;
	[FRAME_FIELDS.IMAGE_ALT_TEXT]?: string;
	[FRAME_FIELDS.CONFLUENCE_PAGE_ID]?: string;
	[FRAME_FIELDS.BACKGROUND_COLOR]?: string;
	[FRAME_FIELDS.TEXT_COLOR]?: string;
	[FRAME_FIELDS.LAYOUT]?: Layout;
};

export enum NavigationStyle {
	PROGRESS_CIRCLES = 'progress-circles',
	THUMBNAILS = 'thumbnails',
}

export enum FrameSizes {
	EXTRA_SMALL = 'extraSmall',
	HERO = 'hero',
}

export { CornerStyle, Layout };
export { FRAME_FIELDS };
